// ..........this function for add only two digits after floating value and comma seperator in ruppes value......

export const formatIndianPrice = (price) => {
  if (!price) return '0';
 
  const hasDecimal = Number(price) % 1 !== 0;
 
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  }).format(price);
};